



































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'
import Local from '@/app/module/local'

@Component({
  components: {
    PageTitle
  }
})
export default class AccountSearch extends Vue {
  private account: number = this.$store.state.accountState.choiceAccountType
  private search: string = this.$store.state.accountState.searchText
  private constantValue: any = []

  @Prop() private count!: number

  private doAccountSearch () {
    /* ユーザータイプで絞り込み */
    this.$store.commit('accountState/setChoiceAccountType', this.account)

    /* キーワード検索 */
    this.$store.commit('accountState/setSearchText', this.search)

    this.$emit('search-list')
  }

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
  }

  private doClear () {
    this.account = 0
    this.search = ''

    /* stateリセット */
    this.$store.commit('accountState/setChoiceAccountType', 0)
    this.$store.commit('accountState/setSearchText', '')
    this.$store.commit('accountState/setSortName', 'name')
    this.$store.commit('accountState/setSortAsc', true)

    this.$emit('reset-list')
    this.$forceUpdate()
  }
}
